import React from "react";
import StationInput from "components/StationInput";
import t from "lib/i18n";
import Select from "components/ui/Select";
import "styles/components/via-avoid.scss";
import { TICKET_TYPES } from "consts";

const ViaAvoid = ({ setValue, viaAvoid, viaAvoidType, errors }) => {
  const onTypeChange = value => {
    setValue("viaAvoidType", value);
  };

  return (
    <div className="otrl-jp__via-avoid">
      <Select className="otrl-jp__via-avoid__type" onChange={onTypeChange} value={viaAvoidType}>
        <option value="via">Via</option>
        <option value="avoid">Avoid</option>
      </Select>
      <div className="otrl-jp__station-selector">
        <StationInput
          className="otrl-jp__station-selector__from"
          location={false}
          name="viaAvoid"
          placeholder={t(`station.${viaAvoidType}.placeholder`)}
          setValue={setValue}
          value={viaAvoid}
          ticketType={TICKET_TYPES.POINT}
          errors={errors}
        />
      </div>
    </div>
  );
};

export default ViaAvoid;
